import React, { useState, Suspense } from "react";
import Layout from "../components/layout";
import { Link } from "gatsby";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import SEO from "@accrosoft-ltd/accropress-websites-components/dist/esm/seo";
import WigLoader from "@accrosoft-ltd/accropress-websites-components/dist/esm/wigLoader";
import WeducNewsFeed from "@accrosoft-ltd/accropress-websites-components/dist/esm/weducNewsfeed";
import WeducDairyDates from "@accrosoft-ltd/accropress-websites-components/dist/esm/weducDairyDates";
import buildMediaContent from "@accrosoft-ltd/accropress-websites-components/dist/esm/buildMediaContent";
import NoticesSlickSlider from "../components/NoticesSlickSlider";
import BasicSlider from "../components/BasicSlider";
import "../components/wig-bundle.css";
import { returnResizedImageURL } from "@accrosoft-ltd/accropress-websites-components/dist/esm/imgUtils";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

require("es6-promise").polyfill();

var moment = require("moment");

export function NoticeTemplate(props) {
  return /*#__PURE__*/_jsx("span", {
    children: props.data.attachment && props.data.attachment[0] && props.data.attachment[0].external_url ? /*#__PURE__*/_jsxs("a", {
      href: props.data.attachment[0].external_url,
      title: props.data.attachment[0].title,
      target: "_blank",
      children: [/*#__PURE__*/_jsxs("strong", {
        children: [props.data.title.replace(/&nbsp;/g, "").replace(/&pound;/g, "£"), props.data.snippet.replace(/&nbsp;/g, "").replace(/&pound;/g, "£") && ": "]
      }), props.data.snippet.replace(/&nbsp;/g, "").replace(/&pound;/g, "£")]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("strong", {
        children: [props.data.title.replace(/&nbsp;/g, "").replace(/&pound;/g, "£"), props.data.snippet.replace(/&nbsp;/g, "").replace(/&pound;/g, "£") && ": "]
      }), props.data.snippet.replace(/&nbsp;/g, "").replace(/&pound;/g, "£")]
    })
  });
}
export default function HomepagePagePage(_ref) {
  var _jsx2;

  var _ref$pageContext = _ref.pageContext,
      integratorData = _ref$pageContext.integratorData,
      contentMetaData = _ref$pageContext.contentMetaData,
      contentDataData = _ref$pageContext.contentDataData,
      navResultData = _ref$pageContext.navResultData,
      pluginOptions = _ref$pageContext.pluginOptions,
      props = _ref.props;
  var config = pluginOptions;

  var _useState = useState(true),
      toggled = _useState[0],
      setToggled = _useState[1];

  var _useState2 = useState(false),
      modalOpen = _useState2[0],
      setModalOpen = _useState2[1];

  var _useState3 = useState({}),
      modalData = _useState3[0],
      setModalData = _useState3[1];

  var _useState4 = useState(false),
      noticesMainLoaded = _useState4[0],
      setNoticesMainLoaded = _useState4[1];

  var _useState5 = useState(false),
      noticesEmergencyLoaded = _useState5[0],
      setNoticesEmergencyLoaded = _useState5[1];

  var _useState6 = useState(false),
      newsfeedLoaded = _useState6[0],
      setNewsfeedLoaded = _useState6[1];

  var _useState7 = useState(false),
      calendarEventsLoaded = _useState7[0],
      setCalendarEventsLoaded = _useState7[1];

  var updateAndShowModal = function updateAndShowModal(title, description, postType, attachment) {
    setModalData({
      title: title,
      description: description,
      postType: postType,
      attachment: attachment
    });
    setModalOpen(true);
  };

  console.log(contentDataData);
  return /*#__PURE__*/_jsxs(Layout, Object.assign({}, props, {
    children: [/*#__PURE__*/_jsx(SEO, {
      navResultData: navResultData,
      contentDataData: contentDataData,
      integratorData: integratorData,
      contentMetaData: contentMetaData
    }), contentDataData && contentDataData.length > 0 ? /*#__PURE__*/_jsxs("div", {
      className: "main-page-wrapper loaded",
      children: [/*#__PURE__*/_jsx("div", {
        className: "banner home-banner",
        children: contentDataData[0] && contentDataData[0].children[1] && contentDataData[0].children[3].children && contentDataData[0].children[3].children.length > 0 && /*#__PURE__*/_jsx(BasicSlider, (_jsx2 = {
          OverlayContainer: /*#__PURE__*/_jsx("div", {
            className: "container",
            children: /*#__PURE__*/_jsxs("div", {
              className: "bannerWrapper",
              children: [/*#__PURE__*/_jsxs("div", {
                className: "bannerText",
                children: [contentDataData[0] && contentDataData[0].children[0] && contentDataData[0].children[0].value && /*#__PURE__*/_jsx("h2", {
                  children: contentDataData[0].children[0].value
                }), contentDataData[0] && contentDataData[0].children[1] && contentDataData[0].children[1].value && /*#__PURE__*/_jsx("h1", {
                  children: contentDataData[0].children[1].value
                })]
              }), /*#__PURE__*/_jsx("div", {
                class: "line"
              }), /*#__PURE__*/_jsx("div", {
                class: "learn-more-button",
                children: /*#__PURE__*/_jsx("a", {
                  href: "#section-2",
                  children: "Learn More"
                })
              })]
            })
          }),
          onBeforeChangeFunction: function onBeforeChangeFunction(type, previous, next) {
            return null;
          },
          height: "600px",
          shouldDisplayButtons: false
        }, _jsx2["onBeforeChangeFunction"] = function onBeforeChangeFunction(type, next) {
          return null;
        }, _jsx2["onBeforeChangeFunction"] = function onBeforeChangeFunction(type, next) {
          return null;
        }, _jsx2.slides = contentDataData[0].children[3].children, _jsx2))
      }), /*#__PURE__*/_jsx("div", {
        className: "divider"
      }), /*#__PURE__*/_jsxs("div", {
        id: "mainContentWrapper",
        className: "mainContentWrapper home",
        children: [/*#__PURE__*/_jsx("div", {
          className: "info-container",
          children: /*#__PURE__*/_jsx("div", {
            className: "row",
            children: /*#__PURE__*/_jsxs("div", {
              class: "container",
              children: [/*#__PURE__*/_jsx("h2", {
                class: "text-center",
                children: contentDataData[1].children[0].children[1][1].value
              }), /*#__PURE__*/_jsx("div", {
                class: "text-center mt-3",
                children: /*#__PURE__*/_jsx(WigLoader, {
                  contentDataData: contentDataData,
                  contentMetaData: contentMetaData,
                  contentDataArray: "1",
                  contentDataChild: "0",
                  customDataArray: contentDataData[1].children[0].children[1][2].value,
                  contentDataChildChildChild: "1",
                  AccroPressProdEndpoint: config.AccroPressProdEndpoint,
                  AccroPressLocalEndpoint: config.AccroPressLocalEndpoint,
                  integratorID: config.integratorID,
                  integratorAccessToken: config.integratorAccessToken
                })
              }), /*#__PURE__*/_jsxs("div", {
                class: "row mt-5 mb-5 text-center text-md-left",
                children: [/*#__PURE__*/_jsxs("div", {
                  class: "display-block col-6 col-3-m",
                  children: [/*#__PURE__*/_jsx("div", {
                    class: "d-flex justify-content-center mb-4 mb-md-0 col-6 col-4-m",
                    children: /*#__PURE__*/_jsx("img", {
                      className: "img-respo-second",
                      src: contentDataData[1].children[0].children[2][0].value
                    })
                  }), /*#__PURE__*/_jsxs("div", {
                    class: "col-6 col-8-m",
                    children: [/*#__PURE__*/_jsx("span", {
                      class: "stat",
                      children: contentDataData[1].children[0].children[2][1].value
                    }), /*#__PURE__*/_jsx("div", {
                      class: "stat_desc",
                      children: /*#__PURE__*/_jsx(WigLoader, {
                        contentDataData: contentDataData,
                        contentMetaData: contentMetaData,
                        contentDataArray: "1",
                        contentDataChild: "0",
                        customDataArray: contentDataData[1].children[0].children[2][2].value,
                        contentDataChildChildChild: "1",
                        AccroPressProdEndpoint: config.AccroPressProdEndpoint,
                        AccroPressLocalEndpoint: config.AccroPressLocalEndpoint,
                        integratorID: config.integratorID,
                        integratorAccessToken: config.integratorAccessToken
                      })
                    })]
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  class: "display-block col-6 col-3-m",
                  children: [/*#__PURE__*/_jsx("div", {
                    class: "d-flex justify-content-center mb-4 mb-md-0 col-6 col-4-m",
                    children: /*#__PURE__*/_jsx("img", {
                      className: "img-respo-second",
                      src: contentDataData[1].children[0].children[2][0].value
                    })
                  }), /*#__PURE__*/_jsxs("div", {
                    class: "col-6 col-8-m",
                    children: [/*#__PURE__*/_jsx("span", {
                      class: "stat",
                      children: contentDataData[1].children[0].children[2][1].value
                    }), /*#__PURE__*/_jsx("div", {
                      class: "stat_desc",
                      children: /*#__PURE__*/_jsx(WigLoader, {
                        contentDataData: contentDataData,
                        contentMetaData: contentMetaData,
                        contentDataArray: "1",
                        contentDataChild: "0",
                        customDataArray: contentDataData[1].children[0].children[2][2].value,
                        contentDataChildChildChild: "1",
                        AccroPressProdEndpoint: config.AccroPressProdEndpoint,
                        AccroPressLocalEndpoint: config.AccroPressLocalEndpoint,
                        integratorID: config.integratorID,
                        integratorAccessToken: config.integratorAccessToken
                      })
                    })]
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  class: "display-block col-6 col-3-m",
                  children: [/*#__PURE__*/_jsx("div", {
                    class: "d-flex justify-content-center mb-4 mb-md-0 col-6 col-4-m",
                    children: /*#__PURE__*/_jsx("img", {
                      className: "img-respo-second",
                      src: contentDataData[1].children[0].children[2][0].value
                    })
                  }), /*#__PURE__*/_jsxs("div", {
                    class: "col-6 col-8-m",
                    children: [/*#__PURE__*/_jsx("span", {
                      class: "stat",
                      children: contentDataData[1].children[0].children[2][1].value
                    }), /*#__PURE__*/_jsx("div", {
                      class: "stat_desc",
                      children: /*#__PURE__*/_jsx(WigLoader, {
                        contentDataData: contentDataData,
                        contentMetaData: contentMetaData,
                        contentDataArray: "1",
                        contentDataChild: "0",
                        customDataArray: contentDataData[1].children[0].children[2][2].value,
                        contentDataChildChildChild: "1",
                        AccroPressProdEndpoint: config.AccroPressProdEndpoint,
                        AccroPressLocalEndpoint: config.AccroPressLocalEndpoint,
                        integratorID: config.integratorID,
                        integratorAccessToken: config.integratorAccessToken
                      })
                    })]
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  class: "display-block col-6 col-3-m",
                  children: [/*#__PURE__*/_jsx("div", {
                    class: "d-flex justify-content-center mb-4 mb-md-0 col-6 col-4-m",
                    children: /*#__PURE__*/_jsx("img", {
                      className: "img-respo-second",
                      src: contentDataData[1].children[0].children[2][0].value
                    })
                  }), /*#__PURE__*/_jsxs("div", {
                    class: "col-6 col-8-m",
                    children: [/*#__PURE__*/_jsx("span", {
                      class: "stat",
                      children: contentDataData[1].children[0].children[2][1].value
                    }), /*#__PURE__*/_jsx("div", {
                      class: "stat_desc",
                      children: /*#__PURE__*/_jsx(WigLoader, {
                        contentDataData: contentDataData,
                        contentMetaData: contentMetaData,
                        contentDataArray: "1",
                        contentDataChild: "0",
                        customDataArray: contentDataData[1].children[0].children[2][2].value,
                        contentDataChildChildChild: "1",
                        AccroPressProdEndpoint: config.AccroPressProdEndpoint,
                        AccroPressLocalEndpoint: config.AccroPressLocalEndpoint,
                        integratorID: config.integratorID,
                        integratorAccessToken: config.integratorAccessToken
                      })
                    })]
                  })]
                })]
              })]
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "divider"
        }), /*#__PURE__*/_jsx("div", {
          className: "info-container",
          children: /*#__PURE__*/_jsxs("div", {
            className: "row intro-content",
            children: [/*#__PURE__*/_jsx("h2", {
              class: "text-center-title",
              children: "Our Process"
            }), /*#__PURE__*/_jsxs("div", {
              class: "row mt-5",
              children: [/*#__PURE__*/_jsx("div", {
                class: "col-10 col-4-m margin-auto",
                children: /*#__PURE__*/_jsxs("div", {
                  class: "mr-1 bg_grey our_process p-5 row",
                  children: [/*#__PURE__*/_jsx("div", {
                    class: "col-12 col-4-m",
                    children: /*#__PURE__*/_jsx("img", {
                      className: "img-respo",
                      src: contentDataData[1].children[0].children[0][0].value
                    })
                  }), /*#__PURE__*/_jsxs("div", {
                    class: "col-12 col-8-m",
                    children: [/*#__PURE__*/_jsx("h4", {
                      children: contentDataData[1].children[0].children[0][1].value
                    }), /*#__PURE__*/_jsx(WigLoader, {
                      contentDataData: contentDataData,
                      contentMetaData: contentMetaData,
                      contentDataArray: "1",
                      contentDataChild: "0",
                      customDataArray: contentDataData[1].children[0].children[0][2].value,
                      contentDataChildChildChild: "1",
                      AccroPressProdEndpoint: config.AccroPressProdEndpoint,
                      AccroPressLocalEndpoint: config.AccroPressLocalEndpoint,
                      integratorID: config.integratorID,
                      integratorAccessToken: config.integratorAccessToken
                    })]
                  })]
                })
              }), /*#__PURE__*/_jsx("div", {
                class: "col-10 col-4-m margin-auto",
                children: /*#__PURE__*/_jsxs("div", {
                  class: "bg_grey our_process p-5 row",
                  children: [/*#__PURE__*/_jsx("div", {
                    class: "col-12 col-4-m",
                    children: /*#__PURE__*/_jsx("img", {
                      className: "img-respo",
                      src: contentDataData[1].children[0].children[0][0].value
                    })
                  }), /*#__PURE__*/_jsxs("div", {
                    class: "col-12 col-8-m",
                    children: [/*#__PURE__*/_jsx("h4", {
                      children: contentDataData[1].children[0].children[0][1].value
                    }), /*#__PURE__*/_jsx(WigLoader, {
                      contentDataData: contentDataData,
                      contentMetaData: contentMetaData,
                      contentDataArray: "1",
                      contentDataChild: "0",
                      customDataArray: contentDataData[1].children[0].children[0][2].value,
                      contentDataChildChildChild: "1",
                      AccroPressProdEndpoint: config.AccroPressProdEndpoint,
                      AccroPressLocalEndpoint: config.AccroPressLocalEndpoint,
                      integratorID: config.integratorID,
                      integratorAccessToken: config.integratorAccessToken
                    })]
                  })]
                })
              }), /*#__PURE__*/_jsx("div", {
                class: "col-10 col-4-m margin-auto",
                children: /*#__PURE__*/_jsxs("div", {
                  class: "ml-1 bg_grey our_process p-5 row",
                  children: [/*#__PURE__*/_jsx("div", {
                    class: "col-12 col-4-m",
                    children: /*#__PURE__*/_jsx("img", {
                      className: "img-respo",
                      src: contentDataData[1].children[0].children[0][0].value
                    })
                  }), /*#__PURE__*/_jsxs("div", {
                    class: "col-12 col-8-m",
                    children: [/*#__PURE__*/_jsx("h4", {
                      children: contentDataData[1].children[0].children[0][1].value
                    }), /*#__PURE__*/_jsx(WigLoader, {
                      contentDataData: contentDataData,
                      contentMetaData: contentMetaData,
                      contentDataArray: "1",
                      contentDataChild: "0",
                      customDataArray: contentDataData[1].children[0].children[0][2].value,
                      contentDataChildChildChild: "1",
                      AccroPressProdEndpoint: config.AccroPressProdEndpoint,
                      AccroPressLocalEndpoint: config.AccroPressLocalEndpoint,
                      integratorID: config.integratorID,
                      integratorAccessToken: config.integratorAccessToken
                    })]
                  })]
                })
              })]
            })]
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "divider"
        }), /*#__PURE__*/_jsx("div", {
          className: "border"
        })]
      }), /*#__PURE__*/_jsx(Modal, {
        classNames: {
          modal: "AccroModal"
        },
        open: modalOpen && modalData ? true : false,
        onClose: function onClose() {
          return setModalOpen(false);
        },
        center: true,
        children: modalData && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            dangerouslySetInnerHTML: {
              __html: modalData.description
            }
          }), modalData.attachment && modalData.attachment.length > 0 && /*#__PURE__*/_jsx("ul", {
            className: "AccroModal_Attachments",
            children: modalData.attachment.map(function (attachment) {
              return /*#__PURE__*/_jsx("li", {
                className: "AccroModal_Attachments_Attachement",
                children: /*#__PURE__*/_jsx("a", {
                  href: attachment.external_url,
                  title: attachment.title,
                  target: "_blank",
                  rel: "noopener noreferer",
                  children: attachment.title
                })
              });
            })
          }), /*#__PURE__*/_jsx("div", {
            dangerouslySetInnerHTML: {
              __html: buildMediaContent(modalData.postType)
            }
          })]
        })
      })]
    }) : /*#__PURE__*/_jsx("div", {
      className: "main-page-wrapper loading"
    })]
  }));
}